module.exports = __webpack_public_path__ + "media/images/zj11-c3-d26740f685c6031ea532d07b2fd5feed.png";